module.exports = __webpack_public_path__ + "img/plus_btn.372ed3c3.png";